export enum ObjectType {
  CallToAction = 'callToAction',
  Comment = 'comment',
  CustomLink = 'customLink',
  EventInformation = 'eventInformation',
  EventRegistration = 'eventRegistration',
  ExternalLinkField = 'externalLinkField',
  FormFieldGroup = 'formFieldGroup',
  FormField = 'formField',
  ImageCarouselItem = 'imageCarouselItem',
  InternalLinkField = 'internalLinkField',
  LinkListItem = 'linkListItem',
  NavigationItem = 'navigationItem',
  NavigationSubMenu = 'navigationSubMenu',
  NavigationSubMenuItem = 'navigationSubMenuItem',
  Reaction = 'reaction',
  SocialInteractions = 'socialInteractions',
  SubjectLinkListItem = 'subjectLinkListItem',
}
